import React from 'react';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';

const TemplateSelector = ({ templates, selectedTemplate, onChange }) => (
  <FormControl fullWidth sx={{ mb: 2 }}>
    <InputLabel id="template-select-label">Select Template</InputLabel>
    <Select
      labelId="template-select-label"
      value={selectedTemplate}
      label="Select Template"
      onChange={onChange}
      sx={{ borderRadius: 2 }}
    >
      <MenuItem value=""><em>None</em></MenuItem>
      {templates.map((template) => (
        <MenuItem key={template.label} value={template.label}>{template.label}</MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default TemplateSelector; 